import {selectPath} from "../selectors/other";
import {ROUTES} from "../app/Routes";
import {useSelector} from "react-redux";

export const useIsPublic = () => {
    const pathProcessed = useSelector(selectPath);
    return pathProcessed === ROUTES.DocPublic;
}
